export interface EmailAction {
  type: "email";
  to: string;
  subject: string;
  body: string;
}

export interface CalendarAction {
  type: "calendar";
  title: string;
  startDate: string;
  endDate: string;
  details?: string;
  location?: string;
}

export type AssistantAction = EmailAction | CalendarAction;

function formatCalendarDate(iso: string): string {
  // iso is "2026-08-15T18:00:00" (asumido hora local Europe/Madrid, sin zona)
  // Formato Google Calendar: YYYYMMDDTHHMMSS (flotante, sin Z → la hora se muestra
  // tal cual en el calendario del usuario, que es Europe/Madrid).
  const m = iso.match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/
  );
  if (!m) return iso;
  const [, y, mo, d, h, mi, s = "00"] = m;
  return `${y}${mo}${d}T${h}${mi}${s}`;
}

export function buildMailto(action: EmailAction): string {
  const params = new URLSearchParams();
  params.set("subject", action.subject);
  params.set("body", action.body);
  return `mailto:${encodeURIComponent(action.to)}?${params.toString()}`;
}

export function buildCalendarUrl(action: CalendarAction): string {
  const params = new URLSearchParams();
  params.set("action", "TEMPLATE");
  params.set("text", action.title);
  params.set(
    "dates",
    `${formatCalendarDate(action.startDate)}/${formatCalendarDate(action.endDate)}`
  );
  if (action.details) params.set("details", action.details);
  if (action.location) params.set("location", action.location);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function openAction(action: AssistantAction) {
  const url =
    action.type === "email" ? buildMailto(action) : buildCalendarUrl(action);
  window.open(url, "_blank", "noopener,noreferrer");
}
